<div class="min-h-screen flex flex-col bg-[#0A0A0B] font-sans text-[#E0E0E0] selection:bg-[#F27D26] selection:text-black">
  <!-- Top App Header -->
  <app-header 
    [activeTab]="currentTab()" 
    (selectTab)="onSelectTab($event)">
  </app-header>

  <!-- Main View Router / Tab Switcher -->
  <main class="flex-grow">
    <!-- Hero / Full Overview View -->
    @if (currentTab() === 'hero') {
      <div>
        <app-hero-section (navigate)="onSelectTab($event)"></app-hero-section>
        <app-sprint1-section></app-sprint1-section>
        <app-sprint2-section></app-sprint2-section>
        <app-sprint3-section></app-sprint3-section>
        <app-sprint4-section></app-sprint4-section>
        <app-aula1-section (navigateBack)="onSelectTab('aulas')"></app-aula1-section>
      </div>
    }

    <!-- Ementa Curricular (Documento Oficial) -->
    @if (currentTab() === 'ementa') {
      <div>
        <app-ementa-section></app-ementa-section>
      </div>
    }

    <!-- Menu de Aulas / Hub -->
    @if (currentTab() === 'aulas') {
      <div>
        <app-aulas-section (selectAula)="onSelectTab($event)"></app-aulas-section>
      </div>
    }

    <!-- Sprint 1: O Hardware (Perfil) -->
    @if (currentTab() === 'sprint1') {
      <div>
        <app-sprint1-section></app-sprint1-section>
      </div>
    }

    <!-- Sprint 2: Infraestrutura -->
    @if (currentTab() === 'sprint2') {
      <div>
        <app-sprint2-section></app-sprint2-section>
      </div>
    }

    <!-- Sprint 3: Protocolo Ágil (Lean & MVP) -->
    @if (currentTab() === 'sprint3') {
      <div>
        <app-sprint3-section></app-sprint3-section>
      </div>
    }

    <!-- Sprint 4: Deploy do Modelo (Canvas) -->
    @if (currentTab() === 'sprint4') {
      <div>
        <app-sprint4-section></app-sprint4-section>
      </div>
    }

    <!-- Aula 1 & Dinâmica das Dores -->
    @if (currentTab() === 'aula1') {
      <div>
        <app-aula1-section (navigateBack)="onSelectTab('aulas')"></app-aula1-section>
      </div>
    }

    <!-- Aula 2: A Jornada do Empreendedor em TI -->
    @if (currentTab() === 'aula2') {
      <div>
        <app-aula2-section (navigateBack)="onSelectTab('aulas')"></app-aula2-section>
      </div>
    }

    <!-- Aula 3: As 10 CCEs e o Perfil Empreendedor em Redes -->
    @if (currentTab() === 'aula3') {
      <div>
        <app-aula3-section (navigateBack)="onSelectTab('aulas')"></app-aula3-section>
      </div>
    }

    <!-- Aula 4: Tipos de Empreendedorismo e Posicionamento em Redes -->
    @if (currentTab() === 'aula4') {
      <div>
        <app-aula4-section (navigateBack)="onSelectTab('aulas')"></app-aula4-section>
      </div>
    }

    <!-- Aula 5: Estudo de Caso "Fome de Poder" (The Founder) -->
    @if (currentTab() === 'aula5') {
      <div>
        <app-aula5-section (navigateBack)="onSelectTab('aulas')"></app-aula5-section>
      </div>
    }
  </main>

  <!-- Global Footer -->
  <app-footer></app-footer>
</div>
